import { render } from "./odn-modal-store-comment-form.vue?vue&type=template&id=df3a2238"
import script from "./odn-modal-store-comment-form.vue?vue&type=script&lang=js"
export * from "./odn-modal-store-comment-form.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__